module.exports = __webpack_public_path__ + "img/palau.cf694446.svg";